import EventEmitter from "events"
import {IPFS} from "ipfs-core"
import OrbitDB from "orbit-db"
import {useCallback, useContext, useEffect, useRef, useState} from "react"
import {AuthContext} from "../context/Auth.context"
import {BackendContext} from "../context/BackendContext"
import {getOrbitAddress, getOrbitConfig, notifyUpdate} from "../functions/ipfs-orbit"
import {Keys} from "../interfaces/keys"
import {ProfileDB} from "../models/ProfileDB.model"

export const useFetchProfile = (profileDBAddress?: string) => {
  const {ipfs, orbit} = useContext(BackendContext)
  const {keys} = useContext(AuthContext)
  const [profile, setProfile] = useState<ProfileDB>()
  const [profileReplCnt, setProfileReplCnt] = useState(0)
  const profileReplEvent = useRef<EventEmitter>()

  const fetchProfile = useCallback(async (
    ipfs: IPFS,
    orbit: OrbitDB,
    keys: Keys | null,
  ) => {
    if (keys === null) {
      return
    }

    let profile: ProfileDB
    if (!profileDBAddress) {
      const config = await getOrbitConfig(keys)
      const orbitAddress = await getOrbitAddress(
        orbit,
        keys.pk,
        "keyvalue",
        config
      )
      await notifyUpdate(ipfs, orbitAddress)
      profile = await orbit.keyvalue(orbitAddress) as ProfileDB
    } else {
      await notifyUpdate(ipfs, profileDBAddress)
      profile = await orbit.keyvalue(profileDBAddress) as ProfileDB
    }

    await profile.load()
    profileReplEvent.current = profile.events.on("replicated", () => {
      console.log("profile replicated")
      setProfileReplCnt(prevState => prevState + 1)
    })
    setProfile(profile)
  }, [])

  useEffect(() => {
    if (!orbit || !ipfs || keys === undefined) {
      return
    }
    fetchProfile(ipfs, orbit, keys).then()
  }, [ipfs, orbit, keys, fetchProfile])

  useEffect(() => {
    return () => {
      profileReplEvent.current?.removeAllListeners()
    }
  }, [])

  useEffect(() => {
    if (!profile) {
      return
    }

    return () => {
      profile.close().then()
    }
  }, [profile])

  return {
    profile,
    profileReplCnt,
    setProfileReplCnt
  }
}
